<template>
    <div>
        <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="list-item, list-item, list-item"
            v-if="loading"
        ></v-skeleton-loader>
        <v-list v-if="!loading"
            ><v-list-item v-for="room in getRooms" :key="room.id">
                <SoliBtn
                    block
                    @click="$emit('input', room)"
                    :text="room.display ?? room.title"
                    :icon="room.id == assignmentRoomId ? 'assignment' : null"
                    color="soli-grey"
                    outlined
                    class="mb-3"
                >
                </SoliBtn>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        locationId: {
            type: Number,
            default: null,
        },
        all: {
            type: Boolean,
            default: false,
        },
        rooms: {
            type: Array,
            default: null,
        },
        assignmentRoomId: {
            type: Number,
            default: null,
        },
        onlineOnly: {
            type: Boolean,
            default: false,
        },
        inStudioOnly: {
            type: Boolean,
            default: false,
        },
        user_id: {
            type: Number,
            default: null,
        },
        lessonStart: {
            type: Date,
            default: null,
        },
        lessonEnd: {
            type: Date,
            default: null,
        },
        waitlist: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            availableRooms: null,
        };
    },
    methods: {
        getApiRooms() {
            this.loading = true;
            axios
                .get("/api/rooms/available", {
                    params: {
                        location_id:
                            this.locationId ??
                            this.$page.props.auth.user.selected_location.id,
                        onlineOnly: Number(this.onlineOnly),
                        inStudioOnly: Number(this.inStudioOnly),
                        user_id: this.user_id,
                        lessonStart: this.lessonStart,
                        lessonEnd: this.lessonEnd,
                    },
                })
                .then((resp) => {
                    this.availableRooms = resp.data;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
    },
    computed: {
        getRooms() {
            let rooms = this.rooms ?? this.availableRooms;
            /*if (this.waitlist && rooms) {
                rooms.push({
                    id: 0,
                    display: "Off-site Event",
                    title: "Off-site Event",
                });
            }*/
            return rooms;
        },
    },
    mounted() {
        if (!this.rooms) this.getApiRooms();
    },
};
</script>
